import React, {useContext} from "react";
import {UserContext} from "./UserContext";

const ListItemTestResult = props => {
    const {testResult, timeZone} = props;
    const {user} = useContext(UserContext);

    return (
        <tr>
            <td className={'padding-y--m'}>
                <div className={'padding-b--s'}>
                    {testResult.testName}
                </div>
                <div>
                    {testResult.lastName + ', ' + testResult.firstName}
                </div>
            </td>
            <td className={'padding-y--m'}>
                <div className={'ch-listItem-testResults margin-b--s'}>
                    {testResult.testQuestionResults.map((questionResult, index) => (
                        <div key={index} className={'ch-testResult-mark'}>
                            <div className={'ch-testResult-mark-inner ' + (questionResult.mark !== undefined ? (questionResult.result !== undefined && questionResult.result ? 'ch-testResult-mark-success' : 'ch-testResult-mark-fail') : '')}></div>
                        </div>
                    ))}
                </div>
                <div>
                    {testResult.completeDate &&
                        <>
                            <span>Started: {user.dateTimeFormat.format(testResult.startDate)}</span>{' - '}
                            <span><span style={{textTransform: 'capitalize'}}>{testResult.testAssignmentStatus.toLowerCase()}</span>: {user.dateTimeFormat.format(testResult.completeDate)}</span>
                        </>
                    }
                    {!testResult.completeDate && testResult.startDate &&
                        <>Started: {user.dateTimeFormat.format(testResult.startDate)}</>
                    }
                    {!testResult.completeDate && !testResult.startDate && testResult.assignedDate &&
                        <>Assigned: {user.dateTimeFormat.format(testResult.assignedDate)}</>
                    }
                </div>
            </td>
            {!testResult.total &&
                <td align="center" colSpan={2}>
                    <span style={{textTransform: 'capitalize'}}>{testResult.testAssignmentStatus.toLowerCase()}</span>
                </td>
            }
            {testResult.total &&
            <>
                <td align="center">
                    {testResult.mark}/{testResult.maxMark}
                </td>
                <td align="center">
                    {testResult.percentCorrect}%
                </td>
            </>
            }
        </tr>
    )
}

export default ListItemTestResult;